/**
 * State used in rendering DataGridSelectionCell
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
